import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Judet, JudetUpdate } from './judet.interface';

@Injectable({
  providedIn: 'root'
})
export class JudetService {
  private token!: string;
  private httpOptions: any;
  
  private basePath = environment.interop.basePath;

  //Getters
  private getJudeteDTURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudeteDT;
  // private getJudetURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudet;
  private getJudeteActiveUrl = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudeteActive;
  private getJudetePublicUrl = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudeteActivePublic;

  //Update
  private storeJudeteURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.storeJudet;
  private updateJudeteURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.putJudet;
  private changeStatusActiveUrl = this.basePath + environment.interop.urbanism.nomenclatoare.judet.changeStatusJudetActive;
  private changeStatusPublicUrl = this.basePath + environment.interop.urbanism.nomenclatoare.judet.changeStatusJudetPublic;

  private deleteJudeteURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.deleteJudet;

  constructor(private http: HttpClient) {}

  changeStatusActive(id: number) {
    return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
  }

  getJudeteDT() {
    return this.http.get(this.getJudeteDTURL, this.httpOptions);
  }

  addJudet(judetName: Judet) {
    return this.http.post(this.storeJudeteURL, judetName, this.httpOptions);
  }
  
  updateJudet(judet: JudetUpdate) {
    return this.http.put(this.updateJudeteURL, judet, this.httpOptions);
  }
  
  deleteJudet(judetId: number) {
    return this.http.delete(this.deleteJudeteURL + judetId);
  }

  getJudeteActive() {
    return this.http.get(this.getJudeteActiveUrl, this.httpOptions);
  }

  getJudetePublic() {
    return this.http.get(this.getJudetePublicUrl, this.httpOptions);
  }

  changeStatuseActive(id: number) {
    return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
  }

  changeStatusePublic(id: number) {
    return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
